/* ENSO — phone header companion (12 Sep 2026). Styles: assets/enso-header-mobile.css
   Account and Project left the phone bar (concept C), so they are appended to
   the menu drawer as two rows after the nav. Links are cloned from the hidden
   header actions, so hrefs (login vs account) and the project count stay in
   sync with the header's own JS. sections/header.liquid is over the write
   ceiling, hence this. */
(function () {
  function ready(fn) { document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', fn) : fn(); }
  ready(function () {
    var nav = document.querySelector('.enso-mobile-drawer__nav');
    if (!nav || nav.querySelector('.enso-mobile-extras')) return;
    var actions = document.querySelector('.enso-header__actions');
    if (!actions) return;
    var account = null, project = actions.querySelector('.enso-header__project');
    Array.prototype.forEach.call(actions.querySelectorAll('a.enso-header__action'), function (a) {
      /* /account, /account/login, or the new customer-accounts URL /customer_authentication/... */
      if (/\/account|customer_authentication|customer_account/.test(a.getAttribute('href') || '')) account = a;
    });
    var box = document.createElement('div');
    box.className = 'enso-mobile-extras';
    function row(a, label) {
      if (!a) return;
      var link = document.createElement('a');
      link.className = 'enso-mobile-nav-link enso-mobile-extras__link';
      link.href = a.getAttribute('href');
      var svg = a.querySelector('svg');
      if (svg) link.appendChild(svg.cloneNode(true));
      link.appendChild(document.createTextNode(label));
      if (a === project) {
        var c = document.createElement('span');
        c.className = 'enso-mobile-extras__count';
        c.setAttribute('data-project-count', '');
        var src = a.querySelector('[data-project-count]');
        c.textContent = src ? src.textContent : '0';
        if (!src || src.classList.contains('is-empty')) c.classList.add('is-empty');
        link.appendChild(c);
      }
      box.appendChild(link);
    }
    row(account, 'Account');
    row(project, 'My project');
    if (box.children.length) nav.appendChild(box);
  });
})();


/* ENSO — Klaviyo dead-overlay sweep (16 Sep 2026). Companion to the scroll-lock rule in
   snippets/enso-css-global.liquid. It lives in this file only because it must run on every
   template and layout/theme.liquid already loads this script site-wide.

   THE BUG. Closing form Y3qkAJ with the X runs Klaviyo's `klaviyo-fadeout` animation
   (fill-mode forwards) on the form wrapper and sets inline opacity: 0. The wrapper then stays
   in the document as a full-viewport position:fixed, z-index 90000, pointer-events:auto layer
   (measured 1303x1270 on the Arvo PDP, 16 Sep) with the popup card still laid out inside it at
   780x464. Invisible, and it swallows every click on the page — "can't click on anything".

   WHY NOT CSS-ONLY. Klaviyo fires no 'close' event, the popup node keeps its layout, and its
   own computed visibility stays `visible` even when an ancestor is hidden. The only signal
   separating open from closed is on the wrapper: its animation name and its opacity.

   WHY A CLASS, NOT INLINE pointer-events. pointer-events:none on the wrapper alone is not
   enough — Klaviyo re-enables it further down the tree, so the card went on eating clicks in
   the middle of the screen. `.enso-kl-dead *` with !important beats that, and
   visibility:hidden !important also overrides Klaviyo's `visibility: visible` on descendants.

   WHY THREE OPACITY TESTS. Measured on the live page after close: inline style says
   `opacity: 0` while getComputedStyle still reported "1", with animationName
   `klaviyo-fadeout`. Any one signal alone misses the state, so all three are checked — and a
   fade-IN is explicitly excluded so an opening popup is never blanked.

   Delete this and the CSS rule once Klaviyo fixes its close handler, or when the form is
   retired. */
(function () {
  var SEL = '[class*="kl-private-reset-css"]';
  var st = document.createElement('style');
  st.textContent = '.enso-kl-dead,.enso-kl-dead *{pointer-events:none !important;visibility:hidden !important;}';
  (document.head || document.documentElement).appendChild(st);

  function sweep() {
    var nodes = document.querySelectorAll(SEL);
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i], cs = window.getComputedStyle(el);
      if (cs.position !== 'fixed') { el.classList.remove('enso-kl-dead'); continue; }
      var an = cs.animationName || 'none';
      var fadingIn = /fade-?in|slide-?in|show/i.test(an);
      var dead = !fadingIn && (
        /fade-?out|hide/i.test(an) ||
        (el.style && el.style.opacity === '0') ||
        parseFloat(cs.opacity) === 0
      );
      if (dead) el.classList.add('enso-kl-dead');
      else el.classList.remove('enso-kl-dead');
    }
  }

  document.addEventListener('click', function () { setTimeout(sweep, 60); setTimeout(sweep, 500); }, true);
  document.addEventListener('animationend', sweep, true);
  document.addEventListener('transitionend', function (e) { if (e.propertyName === 'opacity') sweep(); }, true);
  setInterval(sweep, 1000);
})();


/* ENSO — the Klaviyo 10% popup waits for the cookie banner (16 Sep 2026).
   Supersedes the CSS-only attempt in snippets/enso-css-global.liquid, which never worked.

   WHY THE CSS RULE NEVER FIRED. It read `body:has(#shopify-pc__banner) .klaviyo-form-Y3qkAJ`.
   There is no such class. Klaviyo carries the form id in a DATA ATTRIBUTE — the only node
   holding Y3qkAJ is <form data-testid="klaviyo-form-Y3qkAJ"> — and every node in the popup
   is classed with the hashed `kl-private-reset-css-<hash>`. Measured on the live homepage,
   16 Sep, popup open: document.querySelectorAll('.klaviyo-form-Y3qkAJ').length === 0.

   AND PRESENCE IS THE WRONG TEST ANYWAY. Shopify's storefront-banner.js does NOT remove the
   banner when it is answered: hideModalAndBanner sets
   getElementById('shopify-pc__banner').style.display = 'none' and the node stays in the
   document for the rest of the session. So `body:has(#shopify-pc__banner)` keeps matching
   after Accept/Decline and would have suppressed the popup permanently. Visibility is the
   test, and only JS can measure it — hence the body class below.

   BEHAVIOUR. While the banner is genuinely on screen, the popup and teaser are hidden. The
   popup is not closed or destroyed, so the moment the visitor answers the banner it appears.
   Two overlays at once means one gets dismissed and the other ignored; the banner cannot be
   deferred (PECR), so the popup is the one that waits.

   The two rules are emitted separately on purpose: :has() is dropped whole by browsers that
   do not support it, and the teaser rule must survive that.

   Delete when form Y3qkAJ is retired. */
(function () {
  var st = document.createElement('style');
  st.textContent =
    'body.enso-cookiebar-on div[class*="kl-teaser-"]{display:none !important;}' +
    'body.enso-cookiebar-on div[class*="kl-private-reset-css"]:has(form[data-testid="klaviyo-form-Y3qkAJ"]){display:none !important;}';
  (document.head || document.documentElement).appendChild(st);

  function onScreen(el) {
    if (!el || !el.isConnected) return false;
    var cs = window.getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) === 0) return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }

  function tick() {
    if (!document.body) return;
    document.body.classList.toggle('enso-cookiebar-on', onScreen(document.getElementById('shopify-pc__banner')));
  }

  tick();
  document.addEventListener('DOMContentLoaded', tick);
  document.addEventListener('visitorConsentCollected', tick);
  document.addEventListener('click', function () { setTimeout(tick, 60); setTimeout(tick, 400); }, true);
  setInterval(tick, 750);
})();
